import axios from 'axios';
import { BaseSyntheticEvent, MouseEvent, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import GetTokenApi, { GetMeApi } from '../api/AuthApi';
import Container, { Content } from '../components/Container/Container';
import Form, { FormButton, FormInput } from '../components/Form/Form';
import Modal from '../components/Modal/Modal';
import { SwalFailed, SwalFailedCustom, SwalLoading, SwalSuccess, SwalSuccessCustom } from '../components/Swal/Swal';
import AuthContext from '../context/AuthContext';
import axiosInstance from '../utils/axiosInstance';
import { GetGenericList, GetMe } from '../utils/GetApi';
import { BaseListView, Me, Parish } from '../utils/Interface';
import { ChurchLogo } from '../assets/ChurchLogo';
import MuiTextField from '../components/TextField/TextField';
import MuiButton from '../components/Button/Button';

const Login = () => {
  const navigate = useNavigate();

  // const {userLogin} = useContext(AuthContext)

  const HandleSubmit = async (ev: React.FormEvent) => {
    ev.preventDefault();
    if (!navigator.onLine) {
      SwalFailedCustom({
        title: 'No Internet Connection!',
        text: 'Please check you internet connection.',
      });
      return;
    }

    SwalLoading();

    const { username, password } = loginData;

    const token = await GetTokenApi({ username, password });
    if (!token) {
      SwalFailedCustom({
        title: 'Log-in Failed',
        text: 'You have entered invalid credentials.',
      });
      return;
    }

    const user = await GetMeApi(token.access_token);
    if (!user) {
      SwalFailedCustom({
        title: 'Log-in Failed',
        text: "There's an error with the account.",
      });
      return;
    }

    const newData = {
      ...token,
      ...user,
    };

    sessionStorage.setItem('authTokens', JSON.stringify(newData));

    sessionStorage.setItem('ProxyKey', '');
    sessionStorage.setItem('ChurchName', '');

    SwalSuccessCustom({
      title: 'Log-in Successful',
      text: 'Welcome to Lampara Parish Accounting!',
    });

    navigate('/home', { preventScrollReset: true });
  };

  const HandleSubmitForgot = async (e: BaseSyntheticEvent) => {
    e.preventDefault();

    if (forgotPasswordInput.email.trim() === '' || forgotPasswordInput.username.trim() === '') {
      return SwalFailed('All fields are required!');
    }
    SwalLoading();
    await axiosInstance
      .post('password-reset/', {
        email: forgotPasswordInput.email,
        user: forgotPasswordInput.username,
      })
      .then((res) => {
        SwalSuccess('The link sent successfuly please check your inbox/spam');
        setForgotPasswordInput({
          email: '',
          username: '',
        });
      })
      .catch((error) => {
        SwalFailed('Username and email does not match');
        // to do : error message validation correct input correct output
      });
  };

  const [loginData, setLoginData] = useState({
    username: '',
    password: '',
  });

  const LoginDataHandler = ({ target: { name, value } }: BaseSyntheticEvent) => {
    setLoginData((prev) => ({ ...prev, [name]: value }));
  };

  const [modals, setModals] = useState({
    forgotPassword: false,
  });

  const showForgotPasswordModal = () => {
    if (modals.forgotPassword) {
      setModals((prev) => ({ ...prev, forgotPassword: false }));
      return;
    }
    setModals((prev) => ({ ...prev, forgotPassword: true }));
  };

  const [forgotPasswordInput, setForgotPasswordInput] = useState({
    email: '',
    username: '',
  });

  const forgotPasswordOnchange = ({ target: { name, value } }: BaseSyntheticEvent) => {
    setForgotPasswordInput((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        display: 'flex',
        background: 'url(img/RevampBackground.jpg) center center / cover no-repeat fixed',
        height: '100vh',
      }}
    >
      <Container minWidth="550px" maxWidth="900px" bgColor="white" padding="32px">
        <Content>
          <div className="flex mt-4">
            <div>
              <ChurchLogo color={'#266950'} />
            </div>
            <div className="text-start ml-2 text-[#266950] font-bold">
              <div>PARISH</div>
              <div>ACCOUNTING</div>
            </div>
          </div>
        </Content>
        <Content>
          <div className="text-start text-3xl font-bold my-5">Login to your Account</div>
        </Content>
        <Form id="loginForm" handleSubmit={HandleSubmit}>
          <Content grid>
            <MuiTextField
              required
              name="username"
              label={`Username`}
              className="!my-4"
              value={loginData.username}
              onChange={LoginDataHandler}
            />
            <MuiTextField
              required
              type="password"
              name="password"
              label={`Password`}
              value={loginData.password}
              onChange={LoginDataHandler}
            />
          </Content>
          <Content>
            <div className="flex justify-end my-2">
              <div onClick={showForgotPasswordModal} className="text-end cursor-pointer text-slate-400">
                Forgot Password?
              </div>
            </div>
          </Content>
          <Content flex>
            <MuiButton variant="primary" className="w-[100%]" type="submit">
              Login
            </MuiButton>
          </Content>
        </Form>
      </Container>
      <Modal
        show={modals.forgotPassword}
        onClose={showForgotPasswordModal}
        name={'forgotPassword'}
        background={'white'}
        width="500px"
        title="Forgot Password"
      >
        <Container>
          <Form id={'loginForm'} handleSubmit={HandleSubmitForgot}>
            <Content>
              <div className="text-start text-slate-400">Enter your email before we reset your password.</div>
            </Content>
            <Content grid>
              <MuiTextField
                name="email"
                label={`Email address`}
                className="!my-4"
                value={forgotPasswordInput.email}
                onChange={forgotPasswordOnchange}
              />
              <MuiTextField name="username" label={`Username`} value={forgotPasswordInput.username} onChange={forgotPasswordOnchange} />
            </Content>
            <div className="flex mt-8 justify-end">
              <MuiButton className="!mr-2 !w-[150px]" variant="secondary" type="button" onClick={showForgotPasswordModal}>
                Cancel
              </MuiButton>
              <MuiButton className="!w-[150px]" variant="primary" type="submit">
                Submit
              </MuiButton>
            </div>
          </Form>
        </Container>
      </Modal>
    </div>
  );
};

export default Login;
